import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { getAaveV3Tokens } from '../../allowanceRequiredProtocols';
import { POOL_ADDRESSES } from '../constants';
export var SwapBorrowRateMode = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'swapBorrowRateMode',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveV3Tokens({ chainId: chainId }) }),
                    interestRateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }] }),
                },
            },
            output: {},
        });
    },
});
